import React from "react";

function AgendaTooltip(props) {

    return  <div className="agenda-tooltip" dangerouslySetInnerHTML={{ __html: props.contenido }} style={{top:props.top, left:props.left, display: props.display}}>
            </div>
}
export default AgendaTooltip;